<template>
<!-- 为灵活信号设置页面提供列表上的展示选项，根据信号的name展示不同的para -->
  <div>
    <Row type="flex" justify="center">
      <Col span="15">
        <Slider
          v-model="m_value"
          :max="1"
          :step="0.01"
          :min="0.01"
          show-tip="never"
          @on-change="input_change"
        >
        </Slider>
      </Col>
      <Col offset=1 span="3">
        <InputNumber
          v-model="m_value"
          style="width:100%;minWidth:80px"
          :max="1"
          :min="0.001"
          :step="0.1"
          :active-change="false"
          :formatter="value => `${this.$mul(100, value)} %`"
          :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
          @on-change="input_change"
        >
        </InputNumber>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  name: "flexible_render_slider_view",
  data() {
    return {
      m_value:0,
    }
  },
  props: {
    value: {
      type: Number,
    },
    index: {
      type: Number,
    }
  },
  methods:{
    input_change(new_value) {
      this.$emit("slider_change", {
        "value":this.m_value,
        "index":this.index,
      })
    }
  },
  mounted() {
    this.m_value = this.value
  },
  watch: {
    // m_value(new_value) {
    //    this.$emit("slider_change", {
    //     "value":this.m_value,
    //     "index":this.index,
    //   })
    // },
    value (new_value) {
      this.m_value = new_value
    }
  },
};
</script>
<style>

</style>
